import React, { useState } from 'react';
import { MoodSurvey } from './MoodSurvey';
import { FeedbackSurvey } from './FeedbackSurvey';

export const SatisfactionSurvey = () => {
    const [surveyError, setSurveyError] = useState<boolean>(false);
    const [votingTicket, setVotingTicket] = useState();

    if (surveyError) {
        return null;
    }

    return !votingTicket ? (
        <MoodSurvey setVotingTicket={setVotingTicket} setSurveyError={setSurveyError} />
    ) : (
        <FeedbackSurvey votingTicket={votingTicket} setSurveyError={setSurveyError} />
    );
};
